export const colorSchemeConsumption = [
  '#0C79B1',
  '#FF7D2D',
  '#239F39',
  '#DA252F',
  '#9469BA',
  '#8E564D',
  '#E579C0',
  '#7F7F7F',
  '#00BECD',
  '#113D28',
  '#0000FF',
  '#458B74',
  '#8B4789',
  '#8B6508',
  '#551A8B',
  '#C71585',
  '#8B0000',
  '#0D0D0D',
]

export const colorSchemeHeatingCorrectedConsumption = [
  '#0A699A',
  '#E66F29',
  '#1F8B32',
  '#BF2029',
  '#815CA2',
  '#7C4B44',
  '#C96CA9',
  '#6F6F6F',
  '#00A7B5',
  '#0F351F',
  '#0000E0',
  '#3C7A65',
  '#7A3F78',
  '#785607',
  '#49177A',
  '#AD136F',
  '#780000',
  '#0B0B0B',
]

export const colorSchemeFeeling = [
  '#063D58',
  '#803F17',
  '#117F1C',
  '#6D1218',
  '#4A347D',
  '#472A27',
  '#734060',
  '#404040',
  '#006066',
  '#091E14',
  '#000080',
  '#22453A',
  '#462344',
  '#463204',
  '#2A0D45',
  '#631042',
  '#460000',
  '#060606',
]

export const colorSchemeSecurity = [
  '#8B864E',
  '#8B3A3A',
  '#9ACD32',
  '#00008B',
  '#444D7A',
  '#9B30FF',
  '#CD6600',
  '#B03060',
  '#667267',
  '#B8860B',
  '#5A057F',
  '#EE2C2C',
  '#698B22',
  '#708090',
  '#CD3278',
  '#00868B',
  '#8B3A3A',
  '#8B008B',
  '#00008B',
]
